import { createContext, useContext, useMemo, useState, useCallback } from 'react';

const DispatchContext = createContext(null);

export const useDispatchWorkspace = () => {
  const ctx = useContext(DispatchContext);
  if (!ctx) throw new Error('useDispatchWorkspace must be used within DispatchProvider');
  return ctx;
};

export const DispatchProvider = ({ children }) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedAssignment, setDraggedAssignment] = useState(null);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [focusedTechId, setFocusedTechId] = useState('');
  const [backlogFilter, setBacklogFilter] = useState('');
  const [collapsedSections, setCollapsedSections] = useState({});

  const toggleSection = useCallback((sectionId) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [sectionId]: !(prev[sectionId] ?? true),
    }));
  }, []);

  const clearDrag = useCallback(() => {
    setDraggedItem(null);
    setDraggedAssignment(null);
  }, []);

  const value = useMemo(() => ({
    draggedItem,
    setDraggedItem,
    draggedAssignment,
    setDraggedAssignment,
    selectedDetail,
    setSelectedDetail,
    focusedTechId,
    setFocusedTechId,
    backlogFilter,
    setBacklogFilter,
    collapsedSections,
    toggleSection,
    clearDrag,
  }), [
    draggedItem,
    draggedAssignment,
    selectedDetail,
    focusedTechId,
    backlogFilter,
    collapsedSections,
    toggleSection,
    clearDrag,
  ]);

  return (
    <DispatchContext.Provider value={value}>
      {children}
    </DispatchContext.Provider>
  );
};
